__turbopack_context__.v({
  "fusionSection": "styles-module-scss-module__So2xga__fusionSection",
  "fusionSectionCaption": "styles-module-scss-module__So2xga__fusionSectionCaption",
  "fusionSectionContent": "styles-module-scss-module__So2xga__fusionSectionContent",
  "fusionSectionPadding": "styles-module-scss-module__So2xga__fusionSectionPadding",
  "fusionSectionText": "styles-module-scss-module__So2xga__fusionSectionText",
  "fusionSectionTitle": "styles-module-scss-module__So2xga__fusionSectionTitle",
});
